import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./messages";

Vue.use(VueI18n);

// if you are using moment in your project, now is a good time to set its locale also
// moment.locale(locale);

const languageMappings = {
  // Norwegian translations exist under 'nb' code so other Norwegian codes need to be mapped
  no: "nb",
  nn: "nb",
};

const detectBrowserLanguage = () => {
  let result = "en"; // Default to English
  const browserLanguage = navigator.language || (navigator as any).userLanguage;
  if (browserLanguage) {
    result = browserLanguage.split("-")[0]; // Pick 1st part of xx-XX codes
  }
  return (languageMappings as any)[result] || result;
};

const i18n = new VueI18n({
  locale: localStorage.getItem("unauthenticated-language") || detectBrowserLanguage(),
  messages,
  fallbackLocale: "en",
  /* Silence the "[vue-i18n] Value of key '***' is not a string or function !" spam */
  silentTranslationWarn: true,
});
export default i18n;
